<template lang="pug">
.tab.d-flex.flex-column
  h5.i_mt_1.i_mt_sm_0 {{ tab }}
</template>

<script>
export default {
  name: "Tab",
  props: {
    tab: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/location/tab";
</style>
